/* @flow */

global.ENV = "web";
